import "./style.scss";
import { TranslationService } from "../../../services/translation.service";

function GeneralError({
  showError = true,
  errorText,
  className,
}: {
  showError?: boolean;
  errorText?: string;
  className?: string;
}) {
  return (
    <div aria-live="polite" className={showError && className ? className : ""}>
      {showError && (
        <div className="alert general-error">
          {errorText ?? TranslationService.get("common.generalerror")}
        </div>
      )}
    </div>
  );
}

export default GeneralError;
